<template>
  <div>
    <div class="ts-mt-3 ts-space-y-2">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <a-select
              class="ts-w-full"
              show-search
              v-model="model.dealer_id"
              :allowClear="true"
              :placeholder="$t('dealerUser.searchDealerName')"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="fetching ? undefined : null"
              @search="fetchDealer"
            >
              <a-spin v-if="fetching" slot="notFoundContent" size="small" />
              <a-select-option
                v-for="(d, index) in dealers"
                :key="index"
                :value="d.dealer_id"
              >{{ d.dealer_name }}</a-select-option>
            </a-select>
            <div
              class="validate ts-text-xs"
              v-if="errors.has('dealer_id')"
            >{{ errors.first('dealer_id') }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{ $t('dealerUser.diplayName') }}</label>
          <input type="text" class="form-control" v-model.trim="model.name" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{ $t('dealerUser.userName') }}</label>
          <input type="text" class="form-control" v-model.trim="model.username" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{ $t('dealerUser.password') }}</label>
          <input type="password" class="form-control" v-model.trim="model.password" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{ $t('dealerUser.confirm') }}</label>
          <input type="password" class="form-control" v-model.trim="model.password_confirmation" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 ts-space-x-3 ts-text-right ts-mt-3">
          <ts-button @click.prevent="$emit('close')" >{{ $t('cancel') }}</ts-button>
          <ts-button 
            color="primary" 
            outline
            :waiting="waiting_new"
            @click.prevent="onSaveNew"
          >{{ $t('save_add_new') }}</ts-button>
          <ts-button 
            color="primary"
            :waiting="waiting"
            @click.prevent="onSave"
          >{{ $t('save') }}</ts-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'createSuper',
  data() {
    return {
      fetching: false,
      waiting_new: false,
      waiting: false,
      errors: new Errors(),
      dealers: [],
      model: {
        user_id: 0,
        username: null,
        dealer_id: undefined,
        name: null,
        password: null,
        password_confirmation: null
      }
    }
  },
  methods: {
    ...mapActions('administrator/dealerUser', ['store', 'getDealer']),
    fetchDealer: _.debounce(function(value) {
      if (!value) {
        this.dealers = []
        return
      }
      this.fetching = true
      this.getDealer({
        search: value,
        fields: {
          dealer_profiles: 'dealer_id,dealer_name'
        },
        filter: {
          child_dealer: true,
          dealer_type_id: 2
        },
        page: -1
      })
        .then(response => {
          this.dealers = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching = false
        })
    }, 500),
    onSave() {
      this.errors = new Errors()
      this.waiting = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('close')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSaveNew() {
      this.errors = new Errors()
      this.waiting_new = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    clearInput() {
      this.model.user_id = 0
      this.model.username = null
      this.model.dealer_id = null
      this.model.name = null
      this.model.password = null
      this.model.password_confirmation = null
    }
  }
}
</script>